import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementZhTwLocale from 'element-ui/lib/locale/lang/zh-TW' // element-ui lang
import elementDeLocale from 'element-ui/lib/locale/lang/de' // element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja' // element-ui lang
import elementThLocale from 'element-ui/lib/locale/lang/th' // element-ui lang
import elementKoLocale from 'element-ui/lib/locale/lang/ko' // element-ui lang
import elementRuLocale from 'element-ui/lib/locale/lang/ru-RU' // element-ui lang
import elementFrLocale from 'element-ui/lib/locale/lang/fr' // element-ui lang
import enLocale from './en'
import zhLocale from './zh_cn'
import zhTwLocale from './zh_tw'
import deLocale from './de'
import jaLocale from './ja'
import thLocale from './th'
import koLocale from './ko'
import ruLocale from './ru'
import frLocale from './fr'
import SuiZhLocale from '../components/SimbartUI/lang/zh-CN'
import SuiZhTwLocale from '../components/SimbartUI/lang/zh-TW'
import SuiEnLocale from '../components/SimbartUI/lang/en-US'
import SuiDeLocale from '../components/SimbartUI/lang/de-DE'
import SuiJaLocale from '../components/SimbartUI/lang/ja-JP'
import SuiThLocale from '../components/SimbartUI/lang/th-TH'
import SuiKoLocale from '../components/SimbartUI/lang/ko-KR'
import SuiRuLocale from '../components/SimbartUI/lang/ru-RU'
import SuiFrLocale from '../components/SimbartUI/lang/fr-FR'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
    ...SuiEnLocale
  },
  zh_CN: {
    ...zhLocale,
    ...elementZhLocale,
    ...SuiZhLocale
  },
  zh_TW: {
    ...zhTwLocale,
    ...elementZhTwLocale,
    ...SuiZhTwLocale
  },
  de: {
    ...deLocale,
    ...elementDeLocale,
    ...SuiDeLocale
  },
  ja: {
    ...jaLocale,
    ...elementJaLocale,
    ...SuiJaLocale
  },
  th: {
    ...thLocale,
    ...elementThLocale,
    ...SuiThLocale
  },
  ko: {
    ...koLocale,
    ...elementKoLocale,
    ...SuiKoLocale
  },
  ru: {
    ...ruLocale,
    ...elementRuLocale,
    ...SuiRuLocale
  },
  fr: {
    ...frLocale,
    ...elementFrLocale,
    ...SuiFrLocale
  }
}

// 与 Cookies / 浏览器 language 常见写法对齐，避免 locale 为 zh-CN 时读不到 zh_CN 文案
if (messages.zh_CN && !messages['zh-CN']) {
  messages['zh-CN'] = messages.zh_CN
}
if (messages.zh_TW && !messages['zh-TW']) {
  messages['zh-TW'] = messages.zh_TW
}

let userLang = navigator.language || navigator.userLanguage
if (userLang) {
  userLang = userLang.replace('-', '_')
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || userLang || 'zh_CN',
  // locale: 'zh_CN',
  // set locale messages
  messages
})

userLang = null

// i18n.setLocaleMessage('zh', zh)
// i18n.setLocaleMessage('en', en)

export default i18n



// WEBPACK FOOTER //
// ./src/langs/index.js